export default "__VITE_PUBLIC_ASSET__d16dedc8__"